export default __webpack_public_path__ + "static/media/cashflow-img.a16eb4cd.svg";